import script from "./OperationBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperationBtn.vue?vue&type=script&lang=ts&setup=true"

import "./OperationBtn.vue?vue&type=style&index=0&id=b3bae08e&lang=scss&scope=true"

const __exports__ = script;

export default __exports__